//---------- BurgerMneu / Dropdown ----------//
gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
  $(".m_button").click(function () {
    $("body").toggleClass("active");
    $(".hamBurger-menu").toggleClass("open-menu");

    if ($("body").hasClass("active")) {
      $("body").css("overflow", "hidden");
      $(".page-template-template-blog .m_button span").css(
        "background-color",
        "#000"
      );
    } else {
      $("body").css("overflow", "");
      $(".page-template-template-blog .m_button span").css(
        "background-color",
        ""
      );
    }
  });

  $("#closeDiv").click(function (event) {
    $(".m_button").click();
  });
  if (document.getElementById("popupEmail")) {
    document.getElementById("popupEmail").addEventListener("change", () => {});
    $("#homepageEmail").on("change", (e) => {
      $("#popupEmail input[type=email]").val(e.target.value);
    });
  }
});

//---------- Stciky Header ----------//
document.addEventListener("DOMContentLoaded", () => {
  // (1) Sticky Header
  var didScroll;
  var lastScrollTop = 0;
  var delta = 4;
  var navbarHeight = $(".site-header").outerHeight();

  $(window).on("scroll", function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(window).scrollTop();
    if (Math.abs(lastScrollTop - st) <= delta) return;
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $(".site-header").removeClass("nav-down").addClass("nav-up");
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height() && st > navbarHeight) {
        $(".site-header").removeClass("nav-up").addClass("nav-down");
      }
    }
    if (st >= 200) {
      $(".site-header").addClass("nav-hiding");
    } else {
      $(".site-header").removeClass("nav-hiding");
    }
    if (st < delta) {
      $(".site-header").removeClass("nav-up nav-down");
    }
    lastScrollTop = st;
  }
});
//Header Popup
document.addEventListener("DOMContentLoaded", function () {
  const showSearchButtons = document.querySelectorAll(
    ".show-search-bar, .wishlist-search-btn"
  );
  const searchPopup = document.querySelector(".popup_overlay");
  const body = document.querySelector("body");

  showSearchButtons.forEach(function (showSearchButton) {
    showSearchButton.addEventListener("click", function () {
      $(".contact-full-name input").focus();
      if (
        searchPopup.style.height === "0px" ||
        searchPopup.style.height === ""
      ) {
        searchPopup.style.height = "100%";
        body.classList.add("popup-active");
      } else {
        searchPopup.style.height = "0";
        body.classList.remove("popup-active");
      }
    });
  });

  searchPopup.addEventListener("click", function (event) {
    if (event.target === searchPopup || event.target.closest(".close-icon")) {
      searchPopup.style.height = "0";
      body.classList.remove("popup-active");
    }
  });
});

//Accordion
document.querySelectorAll(".accordion-item").forEach((item) => {
  item.querySelector(".accordion-item-header").addEventListener("click", () => {
    const isOpen = item.classList.contains("open");

    // Close all open accordion items

    document.querySelectorAll(".accordion-item.open").forEach((openItem) => {
      if (openItem !== item) {
        openItem.classList.remove("open");
      }
    });

    // Hide all images
    document.querySelectorAll(".image").forEach((image) => {
      image.classList.remove("visible");
    });

    document.querySelectorAll(".image-desktop").forEach((image) => {
      image.classList.remove("visible");
    });
    // Toggle the "open" class on the clicked item
    item.classList.toggle("open", !isOpen);

    if (item.classList.contains("open")) {
      let dataIndex = item.getAttribute("data-index");
      let imageDiv = document.querySelector(
        `.image-desktop[data-index="${dataIndex}"]`
      );
      imageDiv.classList.add("visible");
    }
    // If the clicked item is open, show its corresponding image
    if (!isOpen) {
      const index = item.getAttribute("data-index");
      const image = document.querySelector(`.image[data-index="${index}"]`);
      if (image) {
        image.classList.add("visible");
      }
    }
  });
});

//Tab//

$(document).ready(function () {
  if (document.querySelector("#growthsvg")) {
    document.querySelector("#growthsvg").classList.add("active");
  }

  $(`.tab-pane`).not(":first-child").hide();

  const buttons = document.querySelectorAll(".slideshow-button"); // Select all slideshow buttons
  const totalSvg = 3; // Total number of images in the slideshow
  let currentIndex = 0; // Initialize the current index of the slideshow
  let timeoutId, resetTimeoutId; // Variables to store timeout IDs

  // Function to show the image based on the provided index
  function showImage(index) {
    const imageURLs = ["growthsvg", "ProfitabilitySvg", "efficencysvg"];
    let currentIndex = document.getElementById(imageURLs[index]);
    imageURLs.forEach((e) => {
      let each = document.getElementById(e);
      if (each) {
        each.classList.remove("active");
      }
    });
    if (currentIndex) {
      $(`.tab-pane`).hide();
      $(`.tab-pane:nth-child(${parseInt(index) + 1})`).show();
      currentIndex.classList.add("active");
    } // Set the image source to the URL at the given index
  }

  // Function to start the slideshow
  if (window.location.pathname === "/") {
    function startSlideshow(currentIndex) {
      showImage(currentIndex); // Show the image at the current index
      buttons[currentIndex].classList.add("animate"); // Add the 'animate' class to the current button
    }
  }

  if (window.location.pathname === "/") {
    $(document).ready(function () {
      setTimeout(() => {
        startSlideshow(0);
      }, 100);

      setTimeout(() => {
        startSlideshow(1);
      }, 5100);

      setTimeout(() => {
        buttons.forEach((e) => {
          e.classList.remove("animate");
          $(".tab-pane").hide();
          $(".tab-pane:nth-child(3)").show();
        });
        startSlideshow(2);
      }, 10100);
    });
  }

  buttons.forEach((e) => {
    e.addEventListener("click", (ee) => {
      let index = ee.target.dataset?.index || 0; // Get the index from the clicked button's data attribute
      buttons.forEach((e) => {
        e.classList.remove("animate");

        // Remove the 'animate' class from all buttons
      });
      // reset the timeouts
      clearTimeout(timeoutId);
      clearTimeout(resetTimeoutId);
      // Restart the slideshow with the clicked button's index after a short delay
      setTimeout(() => {
        startSlideshow(index);
      }, 100);
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth > 768) {
    // Helper function to create and return a timeline with scroll trigger
    const createScrollTimeline = (triggerElement, start, end, options = {}) => {
      return gsap.timeline({
        scrollTrigger: {
          trigger: triggerElement,
          start: start,
          end: end,
          scrub: true,
          ...options, // Additional ScrollTrigger options can be passed in
        },
      });
    };

    // Pinning animation for .ikigai-customer-po

    if (document.querySelector(".customer_po_container")) {
      gsap.to(".customer_po_container", {
        scrollTrigger: {
          trigger: ".customer_po_container",
          start: "center center",
          end: "+=150%",
          pin: true,
          scrub: true,
        },
      });
    }

    // Set initial styles
    if (document.querySelector(".customer_success_solution_content")) {
      gsap.set(
        ".customer_success_solution_content, .customer_po_items_content_div",
        {
          transform: "translateY(0)",
        }
      );
    }
    if (document.querySelector(".customer_po_items_img")) {
      gsap.set(".customer_po_items_img", {
        background:
          "linear-gradient(rgba(1, 128, 121, .95) 28.19%, #8cc6c6 94.37%)",
      });
    }
    if (document.querySelector(".customer_po_items_content")) {
      gsap.set(".customer_po_items_content", { transform: "translateY(0)" });
    }
    if (document.querySelector(".finance-group .delivery-group .sales-group")) {
      gsap.set(".finance-group, .delivery-group, .sales-group", {
        transform: "translate(0,0)",
      });
    }

    // if (document.querySelector(".sales-group circle .delivery-group circle")) {

    // }

    // gsap.set(".sales-group circle, .delivery-group circle", {
    //   opacity: 0.2,
    //   fill: "white",
    //   r: 107,
    // });

    // Check if .sales-group circle or .delivery-group circle exists
    if (
      document.querySelector(".sales-group circle") ||
      document.querySelector(".delivery-group circle")
    ) {
      // Set GSAP properties for .sales-group circle and .delivery-group circle
      gsap.set(".sales-group circle, .delivery-group circle", {
        opacity: 0.2,
        fill: "white",
        r: 107,
      });
    }

    // Check if .po-effect exists

    if (window.location.pathname === "/") {
      // Set GSAP properties for .po-effect
      gsap.set(".po-effect", {
        opacity: 0,
        x: 0,
        y: 0,
      });

      gsap.set(".sales-group .text-group, .delivery-group .text-group", {
        x: 0,
        y: 0,
      });

      gsap.set(".po-effect", {
        opacity: 0,
        x: 0,
        y: 0,
      });

      gsap.set(".with-successpro", {
        opacity: 0,
        transform: "translate(0,-150%)",
      });

      gsap.set(".finance-group circle", {
        opacity: 0.2,
        fill: "white",
        r: 112,
      });
    }

    // Create master timeline

    // let masterTimeline =  createScrollTimeline(
    //   ".customer_po_container",
    //   "center center",
    //   "bottom top-=50%"
    // );
    if (window.location.pathname === "/") {
      createScrollTimeline(
        ".customer_po_container",
        "center center",
        "bottom top-=50%"
      )
        .to(
          ".customer_success_solution_content",
          { translateY: "-100dvh", duration: 20 },
          0
        )
        .to(
          ".customer_po_items_content_div",
          { translateY: "-100dvh", duration: 20 },
          0
        )
        .to(
          ".finance-group circle",
          { fill: "#018079", opacity: 0.8, r: 140, duration: 3 },
          7
        )
        .to(
          ".sales-group circle",
          { fill: "#018079", opacity: 0.8, r: 140, duration: 3 },
          7
        )
        .to(
          ".delivery-group circle",
          { fill: "#018079", opacity: 0.8, r: 140, duration: 3 },
          7
        )
        .to(
          ".finance-group .text-group",
          { transform: "translate(-70px, -20px)", duration: 10 },
          8.2
        )
        .to(
          ".sales-group .text-group",
          { transform: "translate(0, 70px)", duration: 10 },
          8.2
        )
        .to(
          ".customer_po_items_img",
          {
            background: "linear-gradient(#6CB5B1 28.19%, #DFEEEE 94.37%)",
            duration: 10,
          },
          5.2
        )
        .to(
          ".delivery-group .text-group",
          { transform: "translate(70px, -20px)", duration: 10 },
          8.2
        )
        .to(".line-group", { opacity: 0, duration: 1 }, 7)
        .to(".icon-group", { opacity: 0, duration: 1 }, 7)
        .to(".glass-group", { opacity: 0, duration: 1 }, 7)
        .to(
          ".finance-group",
          { transform: "translate(100px, 117px)", duration: 10 },
          8
        )
        .to(
          ".sales-group",
          { transform: "translate(124px, -46px)", duration: 10 },
          8
        )
        .to(".po-effect", { opacity: 1, duration: 4 }, 16)
        .to(
          ".with-successpro",
          { opacity: 1, transform: "translate(0, 150%)", duration: 4 },
          16
        )
        .to(
          ".delivery-group",
          { transform: "translate(-130px, -148px)", duration: 10 },
          8
        );
    }
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        ScrollTrigger.refresh();
      }, 250); // Adjust the debounce delay as needed
    });
  }
});
//po-effect
//animations
// Add animations to the master timeline
// end here

//About Our Story Timeline
function handleheight(isSmall) {
  let our_story_wrapper = document.querySelector(".our_story_wrapper");
  let our_story_wrapper_line = document.querySelector(
    ".our_story_wrapper  .line"
  );
  if (our_story_wrapper_line) {
    our_story_wrapper_line.style.height = isSmall
      ? our_story_wrapper.scrollHeight + "px"
      : our_story_wrapper.clientHeight + "px";
  }
}
document.addEventListener("DOMContentLoaded", () => {
  handleheight();
});
window.addEventListener("resize", () => {
  handleheight(window.innerWidth < 1000 ? "hii" : "");
});

//NavMenu Link Scroll
$(document).ready(function () {
  var swiper = new Swiper(".mySwiper", {
    effect: "creative",
    // loop: true,
    repeat: -1,
    speed: 1000,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    creativeEffect: {
      prev: {
        shadow: true,
        translate: [0, 100, -800],
      },
      next: {
        translate: [0, -400, -100],
      },
    },
  });
});

//About faq tab

// desktop

$(document).ready(function () {
  function initializeTabs() {
    var tabWrapper = $("#tab-block-faq"),
      tabMnu = tabWrapper.find(".tab-mnu-faq li"),
      tabContent = tabWrapper.find(".tab-cont-faq > .tab-pane-faq");

    tabContent.not(":first-child").hide();

    tabMnu.each(function (i) {
      $(this).attr("data-tab", "tab" + i);
    });
    tabContent.each(function (i) {
      $(this).attr("data-tab", "tab" + i);
    });

    tabMnu.click(function () {
      var tabData = $(this).data("tab");
      tabWrapper.find(tabContent).hide();
      tabWrapper
        .find(tabContent)
        .filter("[data-tab=" + tabData + "]")
        .show();

      tabMnu.removeClass("active");
      $(this).addClass("active");
    });

    tabMnu.first().addClass("active");
  }

  if ($(window).width() > 768) {
    initializeTabs();
  }

  $(window).resize(function () {
    if ($(window).width() > 768) {
      initializeTabs();
    } else {
      $(".tab-cont-faq > .tab-pane-faq").show();
    }
  });
});

// mobile
$(document).ready(function () {
  $(".accordion-heading").click(function () {
    var $accordionItem = $(this).next(".accordion-faq");

    // Check if the clicked accordion is already open
    if ($accordionItem.hasClass("open")) {
      // If it's already open, close it
      $accordionItem.removeClass("open");
    } else {
      // Close all other open accordions within the same container
      $(this)
        .closest(".tab-cont-faq")
        .find(".accordion-faq")
        .removeClass("open");

      // Open the clicked accordion
      $accordionItem.addClass("open");
    }
  });
});

// tab name change

$(document).ready(function () {
  var queryParams = new URLSearchParams(window.location.search);
  var tabIndex = queryParams.get("tab");

  function activateTab(index) {
    $(".tab-mnu-faq li").removeClass("active");
    $(".tab-mnu-faq li").eq(index).addClass("active");
    $(".selected-btn.tab-faq").text($(".tab-mnu-faq li").eq(index).text());
  }

  if (
    tabIndex !== null &&
    tabIndex >= 0 &&
    tabIndex < $(".tab-mnu-faq li").length
  ) {
    activateTab(parseInt(tabIndex));
  } else {
    activateTab(0);
  }

  $(".tab-mnu-faq li").click(function () {
    var index = $(this).index();
    activateTab(index);
    if (window.innerWidth <= 768) {
      $(".tab-mnu-faq-about").hide();
    }
  });

  $(".selected-btn-container.tab-faq").click(function () {
    if (window.innerWidth <= 768) {
      $(".tab-mnu-faq-about").toggle();
    }
  });
});

//must need for hyperlink navigation don't remove
$(document).ready(function () {
  if (window.location.hash) {
    setTimeout(() => {
      $("html, body").animate(
        {
          scrollTop: $(window.location.hash).offset().top,
        },
        0
      );
    }, 100);
  }
});

$(document).ready(function () {
  // Create an intersection observer instance
  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.querySelector("svg").classList.add("active");
      } else {
        entry.target.querySelector("svg").classList.remove("active");
      }
    });
  });

  // Select all elements with the class 'timeline_icon' and observe them
  document.querySelectorAll(".timeline_icon").forEach((element) => {
    observer.observe(element);
  });
});

//Scroll to sections
function scrollToSection(sectionId) {
  document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
}

//Blog Tab
$(document).ready(function () {
  var tabWrapper = $("#tab-block-blog"),
    tabMnu = tabWrapper.find(".tab-mnu-blog  li"),
    tabContent = tabWrapper.find(".tab-cont-blog > .tab-pane-blog");

  tabContent.not(":first-child").hide();

  tabMnu.each(function (i) {
    $(this).attr("data-tab", "tab" + i);
  });
  tabContent.each(function (i) {
    $(this).attr("data-tab", "tab" + i);
  });

  tabMnu.click(function () {
    var tabData = $(this).data("tab");
    tabWrapper.find(tabContent).hide();
    tabWrapper
      .find(tabContent)
      .filter("[data-tab=" + tabData + "]")
      .show();
  });

  $(".tab-mnu-blog > li").click(function () {
    var before = $(".tab-mnu-blog li.active");
    before.removeClass("active");
    $(this).addClass("active");
  });
});

// about page animation

document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname === "/about/") {
    // about loading
    gsap.set(".load-circle", {
      opacity: "1",
    });
    gsap.to(".load-circle", {
      duration: 0.6,
      opacity: 0,
      ease: "power1.inOut",
      stagger: {
        each: 0.1,
        repeat: -1,
        yoyo: true,
        repeatDelay: 0.5,
      },
    });

    var leftcard = gsap.timeline({
      scrollTrigger: {
        trigger: ".left-card",
        scrub: 0.5,
        ease: "power2.inOut",
        // start: "top center",
        end: "top center",
      },
    });

    leftcard.to(".left-card", {
      x: -210,
      y: -33,
      scrub: 0.5,
      ease: "power2.inOut",
      duration: 0.5,
    });

    var rightcard = gsap.timeline({
      scrollTrigger: {
        trigger: ".right-card",
        scrub: 0.5,
        ease: "power2.inOut",
        // start: "top center", // adjust based on when you want the animation to start
        end: "top center", // adjust based on when you want the animation to end
      },
    });

    rightcard.to(".right-card", {
      x: 210,
      y: -27,
      scrub: 0.5,
      ease: "power2.inOut",
      duration: 0.5,
    });

    // chart
    var leftchart = gsap.timeline({
      scrollTrigger: {
        trigger: ".svg-3",
        scrub: 0.5,
        start: "top center",
        end: "center center",
      },
    });

    leftchart.to(".left-chart", {
      x: 0,
      y: 0,
      scrub: 0.5,
      ease: "power2.inOut",
      duration: 0.5,
    });

    var rightchart = gsap.timeline({
      scrollTrigger: {
        trigger: ".svg-3",
        scrub: 0.5,
        start: "top center",
        end: "center center",
      },
    });

    rightchart.to(".right-chart", {
      x: 0,
      y: 0,
      scrub: 0.5,
      ease: "power2.inOut",
      duration: 0.5,
    });

    var charttopright = gsap.timeline({
      scrollTrigger: {
        trigger: ".svg-3",
        scrub: 0.5,
        start: "top center",
        end: "center center",
      },
    });

    charttopright.to(".chart-top-center", {
      x: 0,
      y: 0,
      scrub: 0.5,
      ease: "power2.inOut",
      duration: 0.5,
    });

    var chartbottomcenter = gsap.timeline({
      scrollTrigger: {
        trigger: ".svg-3",
        scrub: 0.5,
        start: "top center",
        end: "center center",
      },
    });

    chartbottomcenter.to(".chart-bottom-center", {
      x: 0,
      y: 0,
      scrub: 0.5,
      ease: "power2.inOut",
      duration: 0.5,
    });

    var leftbottomchart = gsap.timeline({
      scrollTrigger: {
        trigger: ".svg-3",
        scrub: 0.5,
        start: "top center",
        end: "center center",
      },
    });

    leftbottomchart.to(".left-bottom-chart", {
      x: 0,
      y: 0,
      scrub: 0.5,
      ease: "power2.inOut",
      duration: 0.5,
    });

    var rightbottomchart = gsap.timeline({
      scrollTrigger: {
        trigger: ".svg-3",
        scrub: 0.5,
        start: "top center",
        end: "center center",
      },
    });

    rightbottomchart.to(".right-bottom-chart", {
      x: 0,
      y: 0,
      scrub: 0.5,
      ease: "power2.inOut",
      duration: 0.5,
    });

    // circle animation
    gsap.fromTo(
      ".inner-circle",
      { scale: 1 },
      {
        duration: 2.5,
        repeat: -1,
        scale: 2.8,
        opacity: 0,
        // loop: true,
        repeat: -1,
        ease: "expoScale(0.5, 3, power2.inOut)",
        transformOrigin: "center",
      }
    );

    gsap.fromTo(
      ".inner-circle-2",
      { scale: 1 },
      {
        duration: 2.5,
        repeat: -1,
        scale: 2,
        delay: 0.9,
        opacity: 0,
        // loop: true,
        repeat: -1,
        ease: "expoScale(0.5, 3, power2.inOut)",
        transformOrigin: "center",
      }
    );
  }
});
